<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	#container
	class="container resizable-container-zindex"
	[ngClass]="{ standalone: standalone, 'container-transition': !isResizing }"
	[style.top.px]="y"
	[style.left.px]="x"
	[style.width.px]="width"
	[style.height.px]="height"
	[style.zIndex]="currentZIndex"
>
	<div [ngClass]="{ 'disable-event': isResizing }" class="content-area">
		<ng-content></ng-content>
	</div>

	<div *ngIf="resizable">
		<div
			*ngFor="let direction of directions"
			[ngClass]="'resize-handle resize-handle-' + direction"
			[attr.direction]="direction"
			(mousedown)="resizeStart($event)"
		></div>
	</div>
</div>
